import instance from "./Api";
export default class CheckoutTransparenteService {
  ObterBIN(binCode, callback) {
    instance
      .post(this.host() + "/api/v1/checkout/bin/", binCode)
      .then((response) => {
        callback(null, response.data);
      })
      .catch((error) => {
        callback(error, null);
      });
  }

  ObterCards(callback) {
    instance
      .get(this.host() + "/api/v1/checkout/cards/")
      .then((response) => {
        callback(null, response.data);
      })
      .catch((error) => {
        callback(error, null);
      });
  }

  DeleteCard(cardUuid, callback) {
    instance
      .delete(this.host() + "/api/v1/checkout/cards/" + cardUuid)
      .then((response) => {
        callback(null, response.data);
      })
      .catch((error) => {
        callback(error, null);
      });
  }

  VerifyCaptcha(token, callback) {
    instance
      .post(this.host() + "/api/v1/captcha/verify/", { token })
      .then((response) => {
        callback(null, response.data);
      })
      .catch((error) => {
        callback(error, null);
      });
  }

  PagarComPix(cartUuid, amount, saldo, currency, customerUuid, onSplitPayment, callback) {
    let finalAmount = this.toCents(amount);
    if (onSplitPayment && saldo !== null) {
      finalAmount = this.calcularDiferencaValorAPagar(amount, saldo);
    }
    const body = {
      chartUuid: cartUuid,
      amount: {
        amount: finalAmount,
        currency: currency,
      },
      pix: {
        customer: {
          uuid: customerUuid,
        },
      },
    };

    instance
      .post(this.host() + "/api/v1/checkout/payment/pix", body)
      .then((response) => {
        callback(null, response.data);
      })
      .catch((error) => {
        callback(error, null);
      });
  }

  ObterStatusPix(paymentId, callback) {
    instance
      .get(this.host() + `/api/v1/checkout/payment/pix/${paymentId}`)
      .then((response) => {
        callback(null, response.data);
      })
      .catch((error) => {
        callback(error, null);
      });
  }

  PagarComCartao(cartUuid, amount, saldo, currency, cardData, onSplitPayment, callback) {
    let finalAmount = this.toCents(amount);
    if (onSplitPayment === true && saldo !== null) {
      finalAmount = this.calcularDiferencaValorAPagar(amount, saldo);
    }
    const body = {
      chartUuid: cartUuid,
      amount: {
        amount: finalAmount,
        currency,
      },
      card: {
        token: cardData.token || null,
        saveCard: cardData.saveCard ?? true,
        customer: {
          uuid: cardData.customer?.uuid,
        },
        card: {
          cardName: cardData.cardName ?? "",
          cardNumber: cardData.cardNumber ?? "",
          brand: cardData.brand ?? "DESCONHECIDA",
          holder: cardData.holder ?? "",
          expirationDate: cardData.expirationDate ?? "",
          securityCode: cardData.securityCode ?? "",
        },
      },
    };
    instance
      .post(this.host() + "/api/v1/checkout/payment/card", body)
      .then((response) => callback(null, response.data))
      .catch((error) => {
        console.log("Esta dando erro?");
        console.log(error);
        const errMsg = error.response?.data?.message || error.message;
        callback(errMsg, null);
      });
  }

  toCents(number) {
    return Math.round((number + Number.EPSILON) * 100);
  }

  calcularDiferencaValorAPagar(aPagar, creditosCarteiraFlex) {
    const credits = this.toCents(creditosCarteiraFlex);
    const toPayCents = this.toCents(aPagar);
    return toPayCents - credits;
  }

  onSplitPayment(value) {
    const key = "splitPayment";

    if (typeof value === "boolean") {
      localStorage.setItem(key, JSON.stringify(value));
      return value;
    }

    // Se não foi passado valor, tenta buscar do localStorage
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : false;
  }

  host() {
    return process.env.REACT_APP_HOST_API;
  }
}
